import MUITable from '@mui/material/Table';
import React from 'react';

import { tableMapper } from '~/common/components/PropertyMappers/tableMapper';

type TableProps = React.ComponentProps<typeof MUITable> & {
  variant?: string;
  colorScheme?: string;
};

const Table = React.forwardRef<any, TableProps>(
  ({ children, ...props }, ref) => {
    const tableProps = tableMapper(props);

    return (
      <MUITable ref={ref} {...tableProps}>
        {children}
      </MUITable>
    );
  },
);

Table.displayName = 'Table';

export default Table;
